import CheckWebpFeature from "./src/common/ggfx-client/module/webp-checker"
CheckWebpFeature()

export const onRouteUpdate = ({ location, prevLocation }) => {
  // if (location.pathname.split('?').length > 0) {
  //   window.history.replaceState(null, '', location.pathname);
  // }

  // window.scrollTo(0, 0)

  const params = new URLSearchParams(location.search)
  const _parameter1 = params.get("transType")

  // console.log("pathname", location.pathname)

  // const defaultArea = process.env.GATSBY_DEFAULT_AREA
  //   ? process.env.GATSBY_DEFAULT_AREA
  //   : "London"
  // const defaultArea_Slug = defaultArea.toLowerCase().replace(/ /g, "-")

  // Residential Redirects
  // if (
  //   location.pathname === "/property/" ||
  //   location.pathname === "/property" ||
  //   location.pathname === "/property/for-sale/" ||
  //   location.pathname === "/property/for-sale"
  // ) {
  //   window.location.replace(`/property/for-sale/in-${defaultArea_Slug}/`)
  // }

  // if (
  //   location.pathname === "/property/to-rent/" ||
  //   location.pathname === "/property/to-rent"
  // ) {
  //   window.location.replace(`/property/to-rent/in-${defaultArea_Slug}/`)
  // }
}
